import {
  CartItemInterface,
  ConfigurableCartItem,
  ProductTypeEnum,
  SimpleCartItem,
} from 'types/types';

export const isItemConfigurable = (
  item: CartItemInterface
): item is ConfigurableCartItem =>
  Array.isArray((item as ConfigurableCartItem).options) &&
  !!(item as ConfigurableCartItem).options.length;

export const isItemSimple = (item: CartItemInterface): item is SimpleCartItem =>
  (item as SimpleCartItem).type === ProductTypeEnum.Simple;
